<script>
export default {
  name: 'Less',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#56AF79',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.09922 6.29996H4.89922C4.51422 6.29996 4.19922 6.61496 4.19922 6.99996C4.19922 7.38496 4.51422 7.69996 4.89922 7.69996H9.09922C9.48422 7.69996 9.79922 7.38496 9.79922 6.99996C9.79922 6.61496 9.48422 6.29996 9.09922 6.29996ZM7.00039 12.6C3.91269 12.6 1.40039 10.0877 1.40039 7.00001C1.40039 3.91231 3.91269 1.40001 7.00039 1.40001C10.0881 1.40001 12.6004 3.91231 12.6004 7.00001C12.6004 10.0877 10.0881 12.6 7.00039 12.6ZM7 0C3.1402 0 0 3.1402 0 7C0 10.8598 3.1402 14 7 14C10.8598 14 14 10.8598 14 7C14 3.1402 10.8598 0 7 0Z"
      :fill="color"
    />
  </svg>
</template>
